export const QUIZ_CATEGORIES = [
  {
    id: "all",
    label: "All",
    slug: "all",
  },
  {
    id: "java",
    label: "Java",
    slug: "java",
  },
  {
    id: "dsa",
    label: "DSA",
    slug: "dsa",
  },
  {
    id: "android",
    label: "Android",
    slug: "android",
  },
  {
    id: "spring-boot",
    label: "Spring Boot",
    slug: "spring-boot",
  },
  {
    id: "cloud-devops",
    label: "Cloud and DevOps",
    slug: "cloud-devops",
  },
];

export const QUIZ_SECTIONS = {
  java: [
    {
      id: "basics",
      label: "Basics",
      slug: "basics",
    },
    {
      id: "collections",
      label: "Collections",
      slug: "collections",
    },
    {
      id: "multithreading",
      label: "Multithreading",
      slug: "multithreading",
    },
  ],
  dsa: [
    {
      id: "array-patterns",
      label: "Array Patterns",
      slug: "array-patterns",
    },
  ],
  android: [],
  "spring-boot": [],
  "cloud-devops": [
    {
      id: "linux",
      label: "Linux",
      slug: "linux",
    },
  ],
};

export const quizCategories = QUIZ_CATEGORIES.filter(
  (category) => category.slug !== "all",
).map((category) => category.label);

export const quizzes = [
  {
    id: "java-oop-quiz",
    slug: "java-oop-quiz",
    title: "Java OOP Quiz",
    category: "Java",
    categorySlug: "java",
    section: "Basics",
    sectionSlug: "basics",
    description:
      "Practice object-oriented Java interview questions across classes, constructors, inheritance, polymorphism, encapsulation, abstraction, and interfaces.",
    path: "/quiz/java/basics/java-oop-quiz",
    legacyPath: "/quiz/java-oop-quiz",
    content: "/quizzes/java/java-oop-quiz.html",
    questionCount: 34,
    estimatedTime: "25 min",
    difficulty: "Intermediate",
  },
  {
    id: "java-basics-quiz",
    slug: "java-basics-quiz",
    title: "Java Basics Quiz",
    category: "Java",
    categorySlug: "java",
    section: "Basics",
    sectionSlug: "basics",
    description:
      "Practice core Java interview questions across main method, variables, memory, data types, operators, control flow, methods, and common tricky basics.",
    path: "/quiz/java/basics/java-basics-quiz",
    legacyPath: "/quiz/java-basics-quiz",
    content: "/quizzes/java/java-basics-quiz.html",
    questionCount: 42,
    estimatedTime: "25 min",
    difficulty: "Beginner",
  },
  {
    id: "dsa-array-patterns-set-1",
    slug: "dsa-array-patterns-set-1",
    title: "DSA Array Patterns Quiz Set 1",
    category: "DSA",
    categorySlug: "dsa",
    section: "Array Patterns",
    sectionSlug: "array-patterns",
    description:
      "Practice data structures and algorithms interview questions across array patterns, two-pointer techniques, sliding window, prefix sums, and common problem-solving strategies.",
    path: "/quiz/dsa/array-patterns/dsa-array-patterns-set-1",
    legacyPath: "/quiz/dsa-array-patterns-set-1",
    content: "/quizzes/dsa/array_patterns_20_questions_set1.html",
    questionCount: 20,
    estimatedTime: "30 min",
    difficulty: "Intermediate",
  },
  {
    id: "dsa-array-patterns-set-2",
    slug: "dsa-array-patterns-set-2",
    title: "DSA Array Patterns Quiz Set 2",
    category: "DSA",
    categorySlug: "dsa",
    section: "Array Patterns",
    sectionSlug: "array-patterns",
    description:
      "Practice more data structures and algorithms interview questions across array patterns, two-pointer techniques, sliding window, prefix sums, and common problem-solving strategies.",
    path: "/quiz/dsa/array-patterns/dsa-array-patterns-set-2",
    legacyPath: "/quiz/dsa-array-patterns-set-2",
    content: "/quizzes/dsa/array_patterns_20_questions_set2.html",
    questionCount: 20,
    estimatedTime: "30 min",
    difficulty: "Intermediate",
  },
  {
    id: "linux-developer-quiz",
    slug: "linux-developer-quiz",
    title: "Linux Developer Skills Quiz",
    category: "Cloud and DevOps",
    categorySlug: "cloud-devops",
    section: "Linux",
    sectionSlug: "linux",
    description:
      "Practice practical Linux interview and real-world developer questions across navigation, files, permissions, processes, services, networking, logs, SSH, Bash, Docker, Git, Android builds, Spring Boot deployment, and AWS troubleshooting.",
    path: "/quiz/cloud-devops/linux/linux-developer-quiz",
    legacyPath: "/quiz/linux-developer-quiz",
    content: "/quizzes/cloud_and_devops/linux-developer-quiz.html",
    questionCount: 66,
    estimatedTime: "45 min",
    difficulty: "Intermediate to Advanced",
  },
  {
    id: "solid-principles-scenario-quiz",
    slug: "solid-principles-scenario-quiz",
    title: "SOLID Principles Scenario Quiz",
    category: "Java",
    categorySlug: "java",
    section: "Basics",
    sectionSlug: "basics",
    description:
      "Practice SOLID principles through real-world scenario-based questions, code review drills, Android and backend design examples, and interview-style architecture judgment questions.",
    path: "/quiz/java/basics/solid-principles-scenario-quiz",
    legacyPath: "/quiz/solid-principles-scenario-quiz",
    content: "/quizzes/java/solid-principles-scenario-quiz.html",
    questionCount: 92,
    estimatedTime: "60 min",
    difficulty: "Advanced",
  },
  {
    id: "java-kotlin-interfaces-quiz",
    slug: "java-kotlin-interfaces-quiz",
    title: "Java and Kotlin Interfaces Quiz",
    category: "Java",
    categorySlug: "java",
    section: "Basics",
    sectionSlug: "basics",
    description:
      "Practice practical Java and Kotlin interface questions across contracts, abstraction, polymorphism, SDK design, default and custom implementations, facades, callbacks, and testability.",
    path: "/quiz/java/basics/java-kotlin-interfaces-quiz",
    legacyPath: "/quiz/java-kotlin-interfaces-quiz",
    content: "/quizzes/java/java-kotlin-interfaces-quiz.html",
    questionCount: 79,
    estimatedTime: "45 min",
    difficulty: "Intermediate to Advanced",
  },
];

export const getQuizCategoryBySlug = (categorySlug) =>
  QUIZ_CATEGORIES.find((category) => category.slug === categorySlug);

export const isValidQuizCategorySlug = (categorySlug) =>
  Boolean(getQuizCategoryBySlug(categorySlug));

export const getQuizzesByCategory = (categorySlug) =>
  !categorySlug || categorySlug === "all"
    ? quizzes
    : quizzes.filter((quiz) => quiz.categorySlug === categorySlug);

export const getQuizBySlug = (quizSlug) =>
  quizzes.find((quiz) => quiz.slug === quizSlug);

export const getQuizById = (quizId) =>
  quizzes.find((quiz) => quiz.id === quizId);

export const getQuizPath = (quiz) => quiz?.path || "/quiz";

export const getLegacyQuizPath = (quiz) =>
  quiz?.legacyPath || getQuizPath(quiz);
